import { Button } from "../button.jsx";

export function SubmitButton({ formState, children }) {
  return (
    <Button
      type={"submit"}
      loading={formState.isSubmitting}
      className={formState.isDirty ? "" : "opacity-50"}
    >
      {children}
    </Button>
  );
}
